// export const BASE_URL 									= 				"https://dev-apapi.stackflow.org"
export const BASE_URL 									= 				process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS_ADMIN
export const EP_CONTACT_US 							    = 				'/admin/update/contactus'
export const EP_GET_CONTACT_US 							= 				'/admin/get/contactus'
export const EP_ADMIN_LOGIN 							= 				'/api/login'
export const EP_USER_LOGIN_2FA			    			= 				'/api/login/twofa'
export const EP_ADMIN_LOGOUT 							= 				'/signout'

export const EP_CHANGE_PASSWORD 						=   			'/change/password'

export const EP_DOCUMENT_LINK_API						=				'/common/get/dropbox/files'

export const EP_GENERATE_2FA_QRCODE         			=				'/generate/twofa/qrcode'
export const EP_VERIFY_2FA_QRCODE         				=				'/verify/twofa/secret'
export const EP_DISABLE_2FA_QRCODE						=				'/disable/twofa'

export const EP_GET_DASHBOARD_DATA 			    		= 				'/get/dashboard/data'
export const EP_GET_DASHBOARD_OTHER_DATA 			    = 				'/get/dashboard/other/data'
export const EP_GET_TOTAL_SUBIB 			    		= 				"/get/dashboard/subibdata"
export const EP_GET_TOTAL_DEPOSIT 			    		= 				"/get/dashboard/totaldepositdata"
export const EP_GET_TOTAL_WITHDRAWAL		    		= 				"/get/dashboard/totalwithdrawaldata"
export const EP_GET_TOTAL_CLIENT	    	    		= 				"/get/dashboard/totalclient"

export const EP_GET_ADMIN_LIST 			    			= 				'/admin/get/admins/list'
export const EP_GET_ADMIN_DETAIL 			    		= 				'/admin/get/admins/details'
export const EP_ADD_ADMIN 			    			    = 				'/admin/add/admins'
export const EP_UPDATE_ADMIN_DETAIL 			    	= 				'/admin/update/admin'

export const EP_VERIFY_ADMIN 			    			= 				'/admin/verify/admin'
export const EP_DISABLE_ADMIN 			    			= 				'/admin/disable/admin'
export const EP_VERIFY_CLIENT			    			= 				'/admin/verify/user'
export const EP_DISABLE_CLIENT			    			= 				'/admin/disable/user'
export const EP_DISABLE_ACCOUNT                         =               '/admin/disable/trading'
export const EP_REQUEST_OTP 			    			= 				'/admin/access/other/admin'
export const EP_VERIFY_OTP 			    				= 				'/admin/access/other/admin'
export const EP_BONUS_DISABLE							=				'/admin/disable/bonus'

export const EP_EMAIL_SETTING_LIST 			    		= 				'/email/setting/list'
export const EP_ADD_EMAIL_SETTING 			    		= 				'/add/update/email/setting'
export const EP_DISABLE2FA 								=				'/admin/disable/user/twofa'

export const EP_GET_SUBIB_LIST 			    			= 				'/admin/sub-ib/list'
export const EP_CREATE_CLIENT 			    			= 				'/admin/create/user'
export const EP_GET_USER_LIST 			    			= 				'/admin/get/user/list'
export const CALL_USER 									=				'/call/user'
export const EP_GET_LOGS_LIST 			    			= 				'/admin/user/logs'
export const EP_GET_LOGS_VIEW 			    			= 				''
export const EP_GET_LOGS_DETAIL 			    		= 				'/admin/user/log/details'
export const EP_GET_USER_VIEW 			    			= 				'/admin/get/user/details'
export const EP_UPDATE_CLIENT_DETAIL					=				'/admin/update/user'
export const EP_RESET_PASSWORD 			    			= 				'/admin/reset/user/password'
export const EP_USER_COUNT 			    				= 				'/admin/user/count'
export const EP_ADD_WITHDRAWAL 			    			= 				'/admin/withdrawal/request/otp' 
export const EP_WITHDRAWAL_METHODS 			    		= 				'/admin/get/withdrawal/methods' 
export const EP_ADD_TICKET 			    				= 				'/admin/ticket/request'
export const EP_USER_NOTIFICATIONS 			    		= 				''
export const EP_ADD_INTERNAL_NOTES						= 				'/admin/create/notes'
export const EP_GET_INTERNAL_NOTES 			    		= 				'/admin/get/internal/notes'
export const EP_VERIFY_ACCOUNT 			    			= 				''
export const EP_GET_RISK_METRIX 			    		= 				'/admin/get/risk/metrix'
export const EP_CREATE_TRADING_ACCOUNT					=				'/admin/create/account'

export const EP_GET_TICKET_LIST 						= 				'/admin/list/ticket'
export const EP_TICKET_TRANSFER 						= 				'/admin/ticket/transfer'
export const EP_GET_TICKET_VIEW 						= 				'/admin/ticket/details'
export const EP_TICKET_REASON_LIST 						= 				'/admin/get/ticket/reasons'
export const EP_TICKET_REPLY							=				'/admin/create/ticket/thread'
export const EP_TICKET_APPROVE							=				'/admin/ticket/approve'
export const EP_TICKET_APPROVE_USER						=				'/admin/user/approve'
export const EP_CLOSE_TICKET							=				'/admin/change/ticket/status'
export const EP_TICKET_DOC_APPROVE_REJECT				=				'/admin/ticket/doc/approve'

// export const EP_CREATE_DEPOSIT 							= 				'/deposit/request/operations'
export const EP_CREATE_DEPOSIT 							= 				'/admin/add/deposit/detail'
export const EP_GET_DEPOSIT_LIST 						= 				'/admin/get/deposit/list'
export const EP_GET_DEPOSIT_TRANSACTION 				= 				'/admin/get/transaction/list'
export const EP_GET_DEPOSIT_VIEW 						= 				'/admin/get/deposit/details'
export const EP_EDIT_DEPOSIT_DETAILS 					= 				'/admin/deposit/update'
export const EP_GET_DEPOSIT_TRANSACTION_STATUS 			= 				'/admin/get/transaction/status'

export const EP_GET_BONUS_LIST 							= 				'/admin/get/bonus/list'
export const EP_GET_BONUS_VIEW 							= 				'/admin/get/bonus/details'
export const EP_GET_BONUS_UPDATE						= 				'/admin/update/bonus'
export const EP_ADD_BONUS    						= 				'/admin/add/bonus'
export const EP_ADD_MANUAL_BONUS					= 				'/admin/add/manual/bonus'

export const EP_GET_WITHDRAWAL_LIST 					= 				'/admin/get/withdrawal/list'
export const EP_GET_WITHDRAWAL_VIEW 	    			= 				'/admin/get/withdrawal/details'
export const EP_EDIT_WITHDRAWAL_DETAILS 				= 				'/admin/update/withdrawal/details'
export const EP_GET_ACCOUNT_DETAIL 			    		= 				'/admin/get/getmargininfoex' 

export const EP_GET_TRADING_LIST 						= 				'/admin/get/trading/list'
export const EP_GET_TRADING_VIEW 						= 				'/admin/get/trading/details'
export const EP_EDIT_TRADING_DETAILS 					= 				'/admin/update/trading/details'
export const EP_DELETE_TRADING_ACCOUNT 					= 				''
export const EP_DISABLE_TRADING_ACCOUNT 				= 				'/admin/disable/account'
export const EP_CHANGE_LEVERAGE 						= 				'/admin/update/account'
export const EP_ACCOUNT_CHANGE                          =               '/admin/update/trading/account/info'

export const EP_GET_CITIES_LIST							=				'/admin/get/city/list' 
export const EP_GET_COUNTRIES_LIST						=				'/admin/get/country/list'

export const EP_CREATE_CATEGORY 			    		= 				'/api/blog/add/edit/categories'
export const EP_CREATE_ARTICLE 			    			= 				'/api/blog/add/edit/article'
export const EP_GET_ARTICLE_LIST 			    		= 				'/api/blog/article/list'
export const EP_GET_CAT_LIST 			    			= 				'/api/blog/category/list'
export const EP_GET_CAT_DETAIL 			    			= 				'/api/blog/category/details'
export const EP_GET_ARTICLE_DETAIL 			    		= 				'/api/blog/article/details'

//=============reporting==============================================================================
export const EP_CREATE_COLLATERAL_PORTFOLIO				=				'/add/collateral/report' 
export const EP_GET_COLLATERAL_PORTFOLIO_LIST			=				'/get/collateral/report/list' 
export const EP_DOWNLOAD_COLLATERAL_PORTFOLIO_LIST		=				'/get/collateral/report/file' 

export const EP_CREATE_EMIR_INSTRUMENTS					=				'/add/emir/mifir/report'	
export const EP_GET_EMIR_INSTRUMENTS_LIST				=				'/get/emir/mifir/report/list'	
export const EP_DOWNLOAD_EMIR_INSTRUMENTS_LIST			=				'/get/emir/mifir/report/list/file'	
		
export const EP_CREATE_MIFIR_INSTRUMENTS				=				'/add/mifir/report'
export const EP_GET_MIFIR_INSTRUMENTS_LIST				=				'/get/mifir/report/list'
export const EP_DOWNLOAD_MIFIR_INSTRUMENTS_LIST			=				'/get/mifir/report/list/file'
				
export const EP_CREATE_REPORTING_MEMBER					=				'/add/member/report'
export const EP_GET_REPORTING_MEMBER_LIST				=				'/get/member/report'

export const EP_CREATE_COUPON 			    			= 				'/admin/coupon/create'
export const EP_GET_COUPON_LIST 			    		= 				'/admin/get/coupon/list'
export const EP_GET_PLAN_COUPON_LIST 			    	= 				'/admin/plan/coupon/list'
export const EP_SUB_EXSIST_LIST 			    		= 				'/admin/get/user/subscriptions'
export const EP_SUB_PLAN_LIST 			    			= 				'/admin/subscription/plan/list'
export const EP_SUB_PLAN_DETAIL 			    		= 				'/admin/subscription/plan/detail'
export const EP_SUB_OPER 			    				= 				'/admin/user/subscription/operation'
export const EP_UNSUBSCRIBE 			    			= 				'/admin/user/subscription/end'

export const EP_GET_NOTIFICATION_LISTING 			    = 				'/admin/get/notification/list'

export const EP_GET_COMMISSION_LIST  			        = 				'/admin/get/commission/list'
export const EP_GET_COMMISSION_VIEW     			    = 				'/admin/get/commission/details'
export const EP_GET_COMMISSION_UPDATE   			    = 				'/admin/update/commission/details'

// Become a master
export const EP_MASTER_LIST  			                = 	    		'/admin/list/leaders'
export const EP_MASTER_DETAILS  			            =    	    	'/admin/leader/details'
export const EP_UPDATE_MASTER                           =               '/admin/leader/update'  

//Enable desable internal trasfrer
export const EP_RUN_Enable_DESABLE_TRANSFER 			= 				'/admin/disable/internal-transfer'

// bonus booster campaigns
export const EP_BONUS_CAMPAIGNS_LIST					=				'/admin/bonus-campaigns/list'
export const EP_BONUS_CAMPAIGNS_CREATE					=				'/admin/bonus-campaigns/create'
export const EP_BONUS_CAMPAIGNS_GET						=				'/admin/bonus-campaigns/get'
export const EP_BONUS_CAMPAIGNS_UPDATE					=				'/admin/bonus-campaigns/update'
export const EP_BONUS_CAMPAIGNS_TOGGLE					=				'/admin/bonus-campaigns/toggle'

// bonus booster codes
export const EP_BONUS_CODES_LIST						=				'/admin/bonus-codes/list'
export const EP_BONUS_CODES_CREATE						=				'/admin/bonus-codes/create'
export const EP_BONUS_CODES_BULK						=				'/admin/bonus-codes/bulk'
export const EP_BONUS_CODES_GET							=				'/admin/bonus-codes/get'
export const EP_BONUS_CODES_UPDATE						=				'/admin/bonus-codes/update'
export const EP_BONUS_CODES_TOGGLE						=				'/admin/bonus-codes/toggle'

// bonus booster redemptions
export const EP_BONUS_REDEMPTIONS_LIST					=				'/admin/bonus-redemptions/list'
export const EP_BONUS_REDEMPTIONS_GET					=				'/admin/bonus-redemptions/get'
export const EP_BONUS_REDEMPTIONS_APPROVE				=				'/admin/bonus-redemptions/approve'
export const EP_BONUS_REDEMPTIONS_REJECT				=				'/admin/bonus-redemptions/reject'


// WEBPACK FOOTER //
// ./src/store/api/endpoints.js